import { Elements, RecurlyProvider, ThreeDSecureAction } from '@recurly/react-recurly';
import { Alert } from 'antd';
import React from 'react';
import { RECURLY_PUBLIC_API_KEY } from '../../settings/config';
import CreditCardForm from './CreditCardForm';
import { AttemptType, Token } from '../types';

type Props = {
    attemptType: AttemptType;
    threeDSecureActionToken: string | undefined;
    buttonLabel: string;
    showAvailableCards?: boolean;
    errorMessage?: string;
    isLoading?: boolean;
    onToken: (token: Token) => void;
    on3DSecureResultToken: (token: Token) => void;
    on3DSecureError: (error: any) => void;
    onError: (error: string) => void;
};

export default function CreditCardPaymentMethod({
    attemptType,
    threeDSecureActionToken,
    buttonLabel,
    showAvailableCards,
    errorMessage,
    isLoading,
    onToken,
    on3DSecureResultToken,
    on3DSecureError,
    onError,
}: Props) {
    return (
        <>
            {threeDSecureActionToken && (
                <RecurlyProvider publicKey={RECURLY_PUBLIC_API_KEY}>
                    <div>
                        <Alert
                            message="Your bank requires authentication using 3D Secure"
                            description="Authenticating your payment method..."
                            type="info"
                            showIcon
                        />
                        <ThreeDSecureAction
                            className="recurly-three-d-secure-action"
                            actionTokenId={threeDSecureActionToken}
                            onToken={on3DSecureResultToken}
                            onError={on3DSecureError}
                        />
                    </div>
                </RecurlyProvider>
            )}

            {!threeDSecureActionToken && (
                <RecurlyProvider
                    publicKey={RECURLY_PUBLIC_API_KEY}
                    required={['cvv']}
                >
                    <Elements>
                        <CreditCardForm
                            attemptType={attemptType}
                            buttonLabel={buttonLabel}
                            errorMessage={errorMessage}
                            isLoading={isLoading}
                            showAvailableCards={showAvailableCards}
                            onToken={onToken}
                            onError={onError}
                        />
                    </Elements>
                </RecurlyProvider>
            )}
        </>
    );
}
